export default "__VITE_ASSET__5e97f9f0__"